import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip, Switch, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import { styled } from "@mui/material";
import { ListItem } from "@mui/material";
import CustomSelectFilter from "../../../Filters/SelectFilter";
import Sku_Sto_Chart from "../../SKU-STO-Chart";
import powerBiLogo from "../../../../assets/images/power-bi-logo.png";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
// import { setModuleTabIndex } from '../../../../store/Actions';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "35px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  unitSelect: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "35px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
    marginRight: "80px",
  },
  appBar: {
    padding: "10px",
    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginTop: "2px",
  },
}));

const GraphViewDO_DP = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  handleViewPowerBi,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  // const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  const chartData = [];
  // const [yAxisTitle, setYAxisTitle] = useState('');
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [unitValue, setUniteValue] = useState("Dollars");
  const [countValue, setCountValue] = useState("5");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  // const [graphDate, setGraphDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0]?.name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 100];
  // const storeData = useSelector((state) => state);
  const [sKU_STOGraph, setSKU_STOGraph] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null); // Track which dropdown is open
  const [resetMultiSelect, setResetMultiSelect] = useState(false);
  // const [selectedSavedFilter, setSelectedSavedFilter] = useState(null);
  const [materialList, setMaterialLIst] = useState([]);
  const allData = useSelector((state) => state);
  const getFilteredListByProperty = (list, property) => {
    return list.some((item) => item.hasOwnProperty(property))
      ? list.map((item) => item[property]).filter(Boolean) // Only include non-null, non-undefined values
      : [];
  };
  const dcList = allData?.filter?.filteredList?.DC
    ? getFilteredListByProperty(allData?.filter?.filteredList?.DC, "DC")
    : [];
  const materialIDList = getFilteredListByProperty(materialList, "MaterialID");
  const [showReasonCodes, setShowReasonCodes] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState("04903534");
  const [selectedDC, setSelectedDC] = useState(dcList[0]);

  useEffect(() => {
    const tabsWithHighCount = [
      "Redeploy Cost",
      "COF",
      "STO Moves reason",
      "Primary Payload",
      "Workload",
      "STRs Required",
      "TLs This Month",
      "STRs To Cancel",
      "Past Due STOs",
    ];
    setCountValue(tabsWithHighCount.includes(activeTab) ? "100" : "5");
  }, [activeTab]);

  useEffect(() => {
    if (selectedDC || selectedMaterial || unitValue) {
      skuSTOParameter({
        filter: {
          SelectSKU: selectedMaterial,
          SelectDC: selectedDC,
          Units: unitValue,
        },
      });
    }
  }, [selectedDC, selectedMaterial, unitValue]);

  // Network, Division, PL3, Material, Dedeployer

  const radioOptions = () => {
    const optionsMap = {
      COF: ["Division", "PL3", "Material", "Deployer_id"],
      "Redeploy Cost": [
        "DC",
        "Division",
        "PL3",
        "MaterialID",
        "DeployerUserID",
        "Week",
      ],
      "STO Moves reason": ["Division", "PL3", "Deployer_ID", "SKU"],
      "Capacity Utilization": ["Network", "DC"],
      Workload: ["Redeployment", "Primary"],
      "Primary Payload": ["Division", "PL3", "MaterialID", "DeployerUserID"],
      "STRs Required": ["Division", "PL3", "SKU", "DestinationDC", "OriginDC"],
      "TLs This Month": ["Division", "PL3", "SKU", "DestinationDC", "OriginDC"],
      "STRs To Cancel": ["Division", "PL3", "SKU", "DestinationDC", "OriginDC"],
      "Past Due STOs": ["Division", "PL3", "SKU", "DestinationDC", "OriginDC"],
      "SKU-STO Parameters": [],
    };

    return optionsMap[activeTab] || [];
  };
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions()[0]
  );

  const getGraphData = (params) => {
    if (activeTab !== "SKU-STO Parameters") {
      setLoading(true);
      GraphService.getGraph(params)
        .then((data) => {
          if (data?.data) {
            setGraphData(data?.data?.data ? data?.data?.data : data?.data);
            // setGraphDate(data?.data);
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => setLoading(false));
    } else {
      getSKUMaterialID({
        filter: {
          RecommendedDC: DC,
          Network: Network,
          PL3: PL3,
          Division: Division,
          MaterialID: Products,
          startDate: date?.[0],
          endDate: date?.[1],
        },
      });
    }
  };

  const getSKUMaterialID = (params) => {
    setLoading(true);
    GraphService.materialID(params)
      .then((data) => {
        // setGraphData(data?.data?.data ? data.data.data : data?.data)
        // setGraphDate(data.data)
        setLoading(false);
        if (data?.data) {
          setMaterialLIst(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const skuSTOParameter = (params) => {
    GraphService.skuSTOP(params)
      .then((data) => {
        if (data) {
          setSKU_STOGraph(data);
        }
        // setGraphDate(data.data)
        // setLoading(false)
      })
      .catch((error) => console.error("Error:", error));
  };
  const memoizedParams = useMemo(
    () => ({
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements:
        activeTab === "Outbound Utilization"
          ? topOrBottomValue === "Top"
            ? "Next"
            : topOrBottomValue
          : topOrBottomValue,
      value: activeTab === "Redeploy Cost" ? 1000 : countValue,
      X_Axis: selectedRadioValue,
      Level: role,
      filter: {
        RecommendedDC: DC,
        reasonCode: showReasonCodes,
        Network: Network,
        PL3: PL3,
        Division: Division,
        MaterialID: Products,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    }),
    [
      Module,
      tabValue,
      selectedRadioValue,
      topOrBottomValue,
      countValue,
      role,
      DC,
      Network,
      PL3,
      Division,
      Products,
      date,
      showReasonCodes,
    ]
  );

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter, showReasonCodes]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);

    const newActiveTab = graphViewTabList.filter(
      (item) => item.index === newValue
    )[0].name;
    const defaultRadioOption = radioOptions(newActiveTab)[0];

    const radioValueMap = {
      Workload: "Redeployment",
      COF: "Division",
      "Capacity Utilization": "DC",
      "STO Moves reason": "Division",
      "Redeploy Cost": "DC",
      "Primary Payload": "Division",
    };

    setSelectedRadioValue(radioValueMap[newActiveTab] || defaultRadioOption);
    setTopOrBottomValue("Top");
    setCountValue("5");
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };

  const handleUniteChange = (event) => {
    setUniteValue(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };

  const chartHeader = (activeTab) => {
    if (activeTab === "STRs Required") {
      return "STRs approvals required";
    }
    if (activeTab === "TLs This Month") {
      return "#of TLs";
    }
    if (activeTab === "STRs To Cancel") {
      return "#of STRs";
    }
    if (activeTab === "Past Due STOs") {
      return "#of STOs";
    }
    if (activeTab === "COF") {
      return "COF %";
    }
  };

  const renderChart = () => {
    const chartProps = {
      graphData,
      chartData,
      categoryList,
      showAnnotation: true,
      activeTab,
    };

    if (activeTab === "SKU-STO Parameters") {
      return <Sku_Sto_Chart data={sKU_STOGraph.data} />;
    }
    if (activeTab === "COF" || activeTab === "Capacity Utilization") {
      return (
        <DPBarChart
          graphData={graphData}
          showAnnotation={activeTab === "COF" ? true : false}
          activeTab={activeTab}
          yAxisTitle={activeTab === "COF" ? "COF %" : "Utilization %"}
        />
      );
    }
    if (activeTab === "Redeploy Cost") {
      return (
        <DPGroupedBarLineChart graphData={graphData} activeTab={activeTab} />
      );
    }
    if (
      activeTab === "STO Moves reason" ||
      activeTab === "Workload" ||
      activeTab === "Primary Payload" ||
      (activeTab === "STRs Required" && showReasonCodes === true)
    ) {
      return <DPBarMultiple graphData={graphData} activeTab={activeTab} />;
    }
    return (
      <DoBarChart
        {...chartProps}
        activeTab={activeTab}
        yAxisTitle={chartHeader(activeTab)}
      />
    );
  };

  const handleDropdownToggle = (dropdownIndex) => {
    if (openDropdownIndex === dropdownIndex) {
      setOpenDropdownIndex(null); // Close the dropdown if it's already open
    } else {
      setOpenDropdownIndex(dropdownIndex); // Open the clicked dropdown
    }
  };

  const getTooltipTitle = (item) => {
    switch (item) {
      case "STRs Required":
        return `From DO:  Count of STRs approved where STR status is Accepted.  Filters applicable: Material, PL3, Division, DC, Network, Date Range`;

      case "TLs This Month":
        return `From DO:  Sum of weights of STRs approved converted to truckload (44,500 lbs) equivalent.  Filters applicable: Material, PL3, Division, DC, Network, Date Range`;

      case "STRs To Cancel":
        return `From DO:  Count of STRs canceled where STR status is Rejected.  Filters applicable: Material, PL3, Division, DC, Network, Date Range`;

      case "Outbound Utilization":
        return `From Warehouse capacity & OVTR - Available outbound dock capacity from Warehouse capacity with corrections to match data from transporeon. <br /> OVTR data for actual booking <br />
                Filters applicable: Start and End date, Network and DCs`;

      case "Past Due STOs":
        return `From Past Dues used in DO: Distinct STO/POs where the delivery date should be between date range and the order status is "Order" or "Shipped" as of latest refresh. Filters applicable: Material, PL3, Division, DC, Network, Date Range`;
      case "Recommended Diverts":
        return `From DOM - Number of diverts recommended.<br />
          Filters applicable: Start and End date, Network and DCs`;
      case "Primary Payload":
        return `Payload in Lbs. as identified from Material Transport. Primary payload is defined by network. <br/>
          For ambient: Origin is a plant. For Frozen, Chilled: As per the list of movements defined as primary.`;
      case "COF":
        return "From DOM: Sum of the cases dispatched vs cases ordered for the last 7 days.<br/> Filters applicable: Material, PL3, Division, DC, Network.";
      // Add more cases as needed for each KPI
      case "Redeploy Cost":
        return "From Redeployment: Sum of the transportation cost for deployment in the last 7 days.<br/> Filters applicable: Material, PL3, Division, DC, Network";
      case "STO Moves reason":
        return "From DO output: Number of STRs recommended by DO along with the reason codes:<br/>1. Accepted due to maintaining inventory levels.<br/>2. Accepted to prevent stockouts <br/>3. Accepted for push pull.<br/>Filters applicable: Material, PL3, Division, DC, Network, Date Range";
      case "Workload":
        return "From Redeployment and from Material Transport: The # of SKUs deployed, unique STOs deployed and the TL equivalents of STOs deployed for the selected time range by deployer with split by Primary and Redeployment.<br/>Filters applicable: Material, PL3, Division, DC, Network, Date Range";
      case "Capacity Utilization":
        return "From Inventory snapshot: Utilization of the holding capacity by DC for the selected time period.<br/>Filters applicable: Material, PL3, Division, DC, Network, Date Range";
      case "SKU-STO Parameters":
        return "Details of a SKU at the selected location including stock on hand, stock by type, Inventory at salvage risk, out of stock risk flag including the expected risk end date.";
      default:
        return "This is additional information about the KPI";
    }
  };

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading && !materialIDList[0] ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                    boxShadow:
                      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "20px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "20px",
                    rowGap: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    {activeTab === "SKU-STO Parameters" ? (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                            }}
                          >
                            Select SKU
                          </Typography>
                          <ListItem sx={{ padding: "0px", flex: 1 }}>
                            <CustomSelectFilter
                              toggleDropdown={() => handleDropdownToggle(5)}
                              isOpen={openDropdownIndex === 5}
                              resetMultiSelect={resetMultiSelect}
                              setResetMultiSelect={setResetMultiSelect}
                              title={"All"}
                              singleSelect
                              handleChange={(value) =>
                                setSelectedMaterial(value)
                              }
                              value={selectedMaterial}
                              list={materialIDList}
                              placeHolder={"All"}
                            />
                          </ListItem>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                              marginLeft: "15px",
                            }}
                          >
                            Select DC
                          </Typography>
                          <ListItem sx={{ padding: "0px 15px", flex: 1 }}>
                            <CustomSelectFilter
                              toggleDropdown={() => handleDropdownToggle(4)}
                              isOpen={openDropdownIndex === 4}
                              resetMultiSelect={resetMultiSelect}
                              setResetMultiSelect={setResetMultiSelect}
                              title={"All"}
                              singleSelect
                              handleChange={(value) => setSelectedDC(value)}
                              value={selectedDC}
                              list={dcList}
                              placeHolder={"All"}
                            />
                          </ListItem>
                        </div>
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                              // marginLeft: "18px",
                            }}
                          >
                            Unit
                          </Typography>
                          <ListItem sx={{ padding: "0px", flex: 1 }}>
                            <Select
                              value={unitValue}
                              onChange={handleUniteChange}
                              className={classes.unitSelect}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              // sx={classes.select}
                            >
                              <MenuItem value="Dollars">Dollars</MenuItem>
                              <MenuItem value={"Cases"}>Cases</MenuItem>
                              <MenuItem value={"Pallets"}>Pallets</MenuItem>
                            </Select>
                          </ListItem>
                        </div>
                      </>
                    ) : (
                      <>
                        <Select
                          value={topOrBottomValue}
                          onChange={handleTopBottomChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          //sx={classes.select}
                        >
                          <MenuItem value="Top">Top</MenuItem>
                          <MenuItem value={"Bottom"}>Bottom</MenuItem>
                        </Select>
                        <Select
                          value={countValue}
                          onChange={handleCountChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          //sx={classes.select}
                        >
                          {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "5px",
                      flexWrap: "wrap",
                    }}
                  >
                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={selectedRadioValue === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              selectedRadioValue ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option === "Primary"
                            ? "Primary Deployment"
                            : ["Deployer_id", "Deployer_ID"].includes(option)
                            ? "Deployer ID"
                            : option === "DC"
                            ? "Destination DC"
                            : option}
                        </span>
                      </React.Fragment>
                    ))}
                    <div
                      style={{
                        display: "flex",
                        alignSelf: "center",
                        marginTop: "7px",
                      }}
                    >
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: getTooltipTitle(activeTab),
                            }}
                          />
                        }
                        placement="top"
                      >
                        {(activeTab === "STRs Required" ||
                          activeTab === "TLs This Month" ||
                          activeTab === "STRs To Cancel" ||
                          activeTab === "Past Due STOs") && (
                          <Tooltip title="Open in Power BI" placement="top">
                            <img
                              src={powerBiLogo}
                              alt="Power BI"
                              style={{
                                width: "30px",
                                height: "20px",
                                marginLeft: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleViewPowerBi(activeTab)}
                            />
                          </Tooltip>
                        )}
                        <InfoOutlinedIcon
                          fontSize="small"
                          style={{
                            color: "blue",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                    {activeTab === "STRs Required" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "16px",
                        }}
                      >
                        <Switch
                          checked={showReasonCodes}
                          onChange={() => setShowReasonCodes(!showReasonCodes)}
                          color="primary"
                          inputProps={{ "aria-label": "toggle reason codes" }}
                        />
                        <span style={{ marginLeft: "8px", color: "#359DD0" }}>
                          Reason codes
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewDO_DP.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewDO_DP);
